<div class="tab-pane" id="menu2">
    <div class="row">
        <div>
            <div class="col-xs-12">
                <div class="box-title">
                    <h3>Última actualización:<strong id="cicloViajes"> {{eventsInfo.lastUpdate}}</strong></h3>
                </div>
            </div>
            <div class="col-xs-12">
                <div class="box-center">
                    <div class="box-fecha__text">
                        <p>Elige el período que quieres consultar</p>
                    </div>
                    <div class="box-fecha__select">
                        <input id="daterange" daterangepicker [options]="options" (selected)="dateSelected($event)"  class="date-range" type="text" name="daterange" value="{{datelabel}}" />
                    </div>
                </div>
            </div>
        </div>
        <app-sura-loader *ngIf='loader'></app-sura-loader>
        <div *ngIf='!loader'>
            <div class="col-xs-12">
                <app-resumen-eventos [resumenEventos]='eventsInfo'></app-resumen-eventos>
            </div>
            <div class="col-xs-12" id="mapa">
                <div class="box-eventos-mapa__title">
                    <h4>Eventos en el mapa</h4>
                </div>
            </div>
            <div class="col-xs-12">
                <div class="col-xs-12">
                    <app-resumen-eventosmapa [eventosMapa]='eventsInfo'></app-resumen-eventosmapa>
                </div>
                <div class="col-xs-12 table-eventos">
                    <app-mapa-eventos [travelEvents]='travelEventsMap' *ngIf="!loaderMap"></app-mapa-eventos>
                </div>
            </div>
            <div class="col-xs-12" *ngIf='eventsInfo.events.length > 0'>
                <div class="box-eventos-detalle__title">
                    <h4>Detalle de los eventos</h4>
                </div>
                <div class="box-eventos-detalle">
                    <app-detalle-eventos [events]='eventsInfo.events' (travelEventsEmit)="changeMarkerMap($event)"></app-detalle-eventos>
                </div>
            </div>
        </div>
        <div class="col-xs-12">
            <div class="box-eventos-paginas"></div>
        </div>
    </div>

</div>
